import { Asset, Site, SiteArea, Task } from 'graphql-common';
import FieldNames from '@lib/enums/fieldNames/interventionFieldNames';
import { SelectOption } from '@lib/components/Select/types';

export default function getInterventionDefaultValues({
  site,
  siteArea,
  asset,
  task,
  completions,
}: {
  site?: Site | null;
  siteArea?: SiteArea | null;
  asset?: Asset | null;
  task?: Task | null;
  // Prefilled `taskCompletions` links, e.g. from a bulk "Create intervention"
  // action started from a selection of completions elsewhere (Task
  // Reporting) — passed via router state, not a URL param, since it's the
  // full selection made a moment ago rather than something to bookmark.
  completions?: SelectOption[];
}) {
  // Without an asset the area stands on its own (e.g. from a Task); with one,
  // it must match the asset's area so the two never contradict.
  const shouldPrefillArea =
    siteArea?.id && (!asset?.id || asset.siteAreaId === siteArea.id);
  return {
    [FieldNames.Name]: '',
    [FieldNames.Description]: '',
    [FieldNames.AttachmentsAttached]: [],
    [FieldNames.Code]: '',
    [FieldNames.EstimatedTime]: null,
    [FieldNames.EstimatedDate]: null,
    [FieldNames.LogisticTime]: null,
    [FieldNames.DurationTime]: null,
    [FieldNames.Category]: null,
    [FieldNames.Priority]: null,
    [FieldNames.Status]: null,
    [FieldNames.Supervisor]: null,
    [FieldNames.Assignee]: [],
    [FieldNames.AssigneeList]: [],
    [FieldNames.Site]: site?.id ? { label: site.name, value: site.id } : null,
    [FieldNames.SiteArea]: shouldPrefillArea
      ? { label: siteArea?.name, value: siteArea?.id }
      : null,
    [FieldNames.Asset]: asset?.id
      ? { label: asset?.name, value: asset?.id, data: asset }
      : null,
    // TasksTableMultiselect keys its rows by the recurring task's
    // `groupKey` (not `id`), and the value is sent as `taskGroupKey` — never
    // fall back to the occurrence id, which the create would reject.
    [FieldNames.Task]: task?.groupKey
      ? {
          label: task.name,
          value: task.groupKey,
          data: task,
        }
      : null,
    // Completions only make sense with their Task — should the Task prefill
    // fail, sending them alone would be rejected on submit.
    [FieldNames.Completions]: task?.groupKey ? completions || [] : [],
    [FieldNames.DepartmentLinks]: [],
    // Custom renders
    [FieldNames.DetailsTitle]: null,
    [FieldNames.SubjectsTitle]: null,
    [FieldNames.DepartmentsAndVisibilityTitle]: null,
    [FieldNames.AssignationTitle]: null,
    [FieldNames.TimingTitle]: null,
  };
}
